import React from 'react';
import * as d3 from 'd3';


const SIZE = 60;

export class DonutChart extends React.PureComponent {

    constructor(props) {
        super(props);

        this.svg = React.createRef();
        this.chart = d3.pie().value(value => value);
        this.arc = d3.arc()
            .outerRadius(SIZE / 2)
            .innerRadius(SIZE / 2 - 8);
        this.arcSimple = d3.arc()
            .outerRadius(SIZE / 2 - 4)
            .innerRadius(SIZE / 2 - 4);
    }

    componentDidMount() {
        this.updateChart(this.props.value);
    }

    componentDidUpdate(prevProps) {
        console.log('componentDidUpdate', prevProps.value, this.props.value);
        const value = [this.props.value, 100 - this.props.value];
        this.updateChart(value);
    }

    updateChart(value) {
        const g = d3.select(this.svg.current)
            .append("g")
            .attr("transform", "translate(" + SIZE / 2 + "," + SIZE / 2 + ")")
            .selectAll('.arc')
            .data(this.chart(value))
            .enter().append('g')
            .attr('class', 'arc');

        g.append('path')
            .attr('d', (...args) => {
                const arc = [this.arc, this.arcSimple][args[1]];
                return arc.call(arc, ...args);
            })
            .attr('stroke-width', '2px')
            .attr('shape-rendering', 'geometricPrecision')
            .attr('fill', (d, i) => [this.props.color, 'none'][i])
            .attr('stroke', (d, i) => ['none', this.props.color][i]);
    }

    render() {
        return <div className="donut-chart">
            <svg className="donut-chart__svg" height={SIZE} width={SIZE} ref={this.svg} />
            <div className="donut-chart__info">
                <div className="donut-chart__title" style={{color: this.props.color}}>{this.props.label}</div>
                <div className="donut-chart__value">{this.props.value || 0}%</div>
            </div>
        </div>;
    }
}
